import moment from "moment/moment";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactPaginate from "react-paginate";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { viewIcon } from "../../assets/img";
import { useLazyReviewStatusQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";

const RoomSharing = ({
  getRoomSharingList,
  searchRoomSharing,
  setRoomSharingPage,
  roomSharingCount,
  listRoomSharing,
  paginationRoomSharing,
  rowRoomSharing,
  fromDateRoomSharing,
  toDateRoomSharing,
}) => {
  const dispatch = useDispatch();
  const [btn, setBtn] = useState(false);
  const navigate = useNavigate();

  // RTK QUERY
  const [statusApi] = useLazyReviewStatusQuery();

  const handlePageChange = (selectedObject) => {
    setRoomSharingPage(selectedObject.selected + 1);
  };

  const statusChange = (id) => {
    dispatch(saveLoader(true));
    setBtn(true);
    statusApi(id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setBtn(false);
        if (res?.status == "success") {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          getRoomSharingList(
            searchRoomSharing,
            rowRoomSharing,
            fromDateRoomSharing,
            toDateRoomSharing
          );
        }
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        setBtn(false);
        console.log("err");
      });
  };

  return (
    <div className="block-content">
      <Row>
        <Col md={6}>
          <label className="table-labels f1">
            Total Count : {paginationRoomSharing?.total}
          </label>
        </Col>
      </Row>
      <div className="d-flex gap-3">
        <div className="col-md-2 p-0">
          <select
            className="form-control custom-select"
            onChange={(e) =>
              getRoomSharingList(
                searchRoomSharing,
                e.target.value,
                fromDateRoomSharing,
                toDateRoomSharing
              )
            }
            value={rowRoomSharing}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="col-md-2  p-0">
          <DatePicker
            selected={fromDateRoomSharing}
            onChange={(date) => {
              getRoomSharingList(
                searchRoomSharing,
                rowRoomSharing,
                date,
                toDateRoomSharing
              );
            }}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-2 p-0">
          <DatePicker
            selected={toDateRoomSharing}
            onChange={(date) =>
              getRoomSharingList(
                searchRoomSharing,
                rowRoomSharing,
                fromDateRoomSharing,
                date
              )
            }
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="yyyy-MM-dd"
            todayButton="Today"
            className="form-control custom-select"
            placeholderText="YYYY-MM-DD"
          />
        </div>
        <div className="col-md-3 p-0">
          <input
            className="form-control bg-white"
            placeholder="Eg: Booking Id, Property Id"
            style={{ width: "300px" }}
            onChange={(e) =>
              getRoomSharingList(
                e.target.value,
                rowRoomSharing,
                fromDateRoomSharing,
                toDateRoomSharing
              )
            }
            value={searchRoomSharing}
          />
        </div>
      </div>

      <div className="table-custom-design overflow-scroll">
        <table>
          <thead className="single-book-table">
            <tr className="text-capitalize text-nowrap">
              <th>S.NO</th>
              <th>Date</th>
              <th>Booking ID</th>
              <th>Property ID</th>
              <th>Service Type</th>
              <th>User Name</th>
              <th>Review</th>
              <th>Rating</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {listRoomSharing?.map((item, ind) => {
              return (
                <tr key={ind}>
                  <td>
                    {(paginationRoomSharing?.current_page - 1) *
                      rowRoomSharing +
                      ind +
                      1}
                  </td>
                  <td>
                    {" "}
                    {item?.created_at
                      ? moment(item?.created_at).format("DD-MM-YYYY hh:mm a")
                      : "-"}
                  </td>
                  <td>
                    {item?.booking?.booking_id ? (
                      <button
                        className="link-btn"
                        onClick={() =>
                          navigate("/booked-rooms-view", {
                            state: { type: "view", data: item?.booking },
                          })
                        }
                      >
                        {item?.booking?.booking_id}
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>
                    {item?.property?.property_id ? (
                      <button
                        className="link-btn"
                        onClick={() =>
                          navigate("/property-view", {
                            state: { type: "edit", data: item?.property },
                          })
                        }
                      >
                        {item?.property?.property_id}
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td>{item?.booking?.service_type}</td>
                  <td>{item?.user?.name}</td>
                  <td>{item?.review}</td>
                  <td>{item?.rating}</td>
                  <td>
                    <button
                      className={`${
                        item?.status == 1 ? "btn-success" : "btn-danger"
                      } px-2 py-1 rounded-1 border-0 text-white`}
                      onClick={() => statusChange(item?.id)}
                      disabled={btn}
                    >
                      {item?.status == 1 ? "Active" : "Deactive"}
                    </button>
                  </td>
                  <td>
                    <div className="d-flex flex-column">
                      <button
                        className="cust-btn"
                        onClick={() =>
                          navigate("/review", { state: { data: item } })
                        }
                      >
                        <img src={viewIcon} className="edit-btn" />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="page-inner-cont py-2 d-flex justify-content-end">
        <ReactPaginate
          nextLabel="››"
          onPageChange={handlePageChange}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          pageCount={roomSharingCount}
          previousLabel="‹‹"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </div>
  );
};

export default RoomSharing;
